import { ImageViewerComponent } from 'src/app/component/image-viewer/image-viewer/image-viewer.component';
import { ReviewComponent } from 'src/app/component/review/review.component';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { style } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { ModalController, Platform } from '@ionic/angular';

import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-business',
  templateUrl: './business.page.html',
  styleUrls: ['./business.page.scss'],
})
export class BusinessPage implements OnInit {
  business;
  ads;
  user;
  show = 'info';
  info = 'about';
  campus = 'puebla';
  borrego = false;
  reviews;
  likesHidden = false;
  currentPage = 1;
  currentLoaded = 0;
  pagingEnabled = true;
  iabOptions: InAppBrowserOptions = {
    location: 'no',
    hidenavigationbuttons: 'yes',
    toolbarposition: 'bottom',
    toolbarcolor: '#0e53a1',
    navigationbuttoncolor: '#ffffff',
    hideurlbar: 'yes',
    closebuttoncaption: 'Cerrar',
  };
  updating = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalCtrl: ModalController,
    private iab: InAppBrowser,
    private auth: AuthService,
    private platform: Platform,
    private dataService: DataService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data['special']) {
      this.business = this.route.snapshot.data['special'];
    }
  }

  ionViewDidEnter() {
    this.auth.getUser().then((user) => {
      this.user = user;
      if (this.user.borrego === 1) {
        this.borrego = true;
      }
      if (this.user.campus_current === 1) {
        this.campus = 'puebla';
      } else {
        this.campus = 'toluca';
        if (this.business.location_name.toLowerCase().includes('metepec')) {
          this.campus = 'metepec';
        }
      }
      this.getBusiness();
    });
  }

  getBusiness() {
    // this.business = (await this.apiService.getData("business/" + this.route.snapshot.paramMap.get('id'))).data[0] || null;
    this.apiService.getData('business/' + this.route.snapshot.paramMap.get('id')).then(
      (res) => {
        if (res && res.data && JSON.stringify(res.data[0]) !== JSON.stringify(this.business)) {
          console.log('Cambio, actualizar!');
          this.business = res.data[0];
          this.getReviews();
        }
      },
      (err) => {
        // this.presentToast('Error de conexión con el servidor. Intente nuevamente más tarde.');
        console.log(JSON.stringify(err));
      }
    );
  }

  doInfiniteReviews(infiniteScroll) {
    console.log('Begin async operation');
    this.getReviews().then(() => {
      infiniteScroll.target.complete();
    });
  }

  async goReview() {
    if (!this.business.review) {
      this.business.review = { id: null, answer1: null, comments: null };
    }
    const modal = await this.modalCtrl.create({
      component: ReviewComponent,
      componentProps: {
        id: this.business.review.id,
        business_id: this.business.id,
        answer1: this.business.review.answer1,
        comments: this.business.review.comments,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    modal.onDidDismiss().then((res) => {
      if (res && res.data && res.data === 'help') {
        this.router.navigate(['/tecservice/home/business/' + this.business.id + '/help']);
      } else {
        this.getBusiness();
      }
    });

    return await modal.present();
  }

  async getReviews() {
    // Get category from apiService
    return new Promise((resolve) => {
      this.apiService.getData('reviews/' + this.business.id + '?page=' + this.currentPage).then(
        (res) => {
          if (res.data) {
            if (res.current_page === 1) {
              this.reviews = res.data;
            } else {
              if (this.currentLoaded !== res.last_page) {
                for (const i in res.data) {
                  this.reviews.push(res.data[i]);
                }
              }
            }
            if (res.current_page !== res.last_page) {
              this.currentPage += 1;
            } else {
              // this.pagingEnabledSales = false;
            }
            this.currentLoaded = res.current_page;
          }
          resolve(true);
        },
        (err) => {
          resolve(false);
          console.log(JSON.stringify(err));
        }
      );
    });
  }

  async viewImage(src: string, title: string = '', description: string = '') {
    if (this.platform.is('ios')) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  updateLikes(review, i, action) {
    if (!this.updating) {
      this.updating = true;

      this.apiService
        .postData('likes/' + review.id, { user_id: this.user.id, status: action })
        .then((res) => {
          // Delay the updating flag to avoid liking/unliking duplicate.
          console.log(res);
          review.like_status = res.like_status;
          review.like = res.likes;
          review.dislike = res.dislikes;
        })
        .finally(() => {
          this.updating = false;
        });
    }
  }

  scan(goto = null) {
    const scan = {
      endpoint: 'points',
      reward: {
        id: null,
      },
      business: this.business,
    };
    if (goto && goto === 'calificar') {
      scan.endpoint = 'review';
      this.dataService.setData(goto.id, scan);
      this.router.navigate(['/tecservice/home/business/review/', this.business.id]);
    } else if (goto) {
      scan.endpoint = 'rewards';
      scan.reward = goto;
      this.dataService.setData(goto.id, scan);
      this.router.navigate(['/tecservice/home/business/reward/', goto.id]);
    } else {
      this.dataService.setData(this.business.id, scan);
      this.router.navigate(['/tecservice/home/business/points/', this.business.id]);
    }
  }

  goWhatsapp() {
    if (this.business.whatsapp) {
      this.iab.create('https://api.whatsapp.com/send?phone=' + this.business.whatsapp, '_system');
    }
  }

  goWeb() {
    if (this.business.web) {
      this.iab.create(this.business.web, '_blank', this.iabOptions);
    }
  }

  goPhone() {
    if (this.business.phone1) {
      this.iab.create('tel:' + this.business.phone1, '_system');
    }
  }

  goInstagram() {
    if (this.business.instagram) {
      this.iab.create('instagram://user?username=' + this.business.instagram, '_system');
    }
  }

  goFacebook() {
    if (this.business.facebook) {
      this.iab.create('fb://profile/' + this.business.facebook, '_system');
    }
  }

  goLocation() {
    if (this.business.map) {
      this.viewImage(this.business.map, this.business.name, '');
    } else {
      this.viewImage('/assets/imgs/' + this.campus + '.jpg', '', '');
    }
  }

  goMail() {
    if (this.business.email) {
      this.iab.create('mailto:' + this.business.email, '_system');
    }
  }
}
